export default __webpack_public_path__ + "static/media/global-warming.9e8ac040.png";